import BreadcrumbsStore from "../stores/BreadcrumbsStore";

export default {
  methods: {
    setBreadcrumb (text, to = null) {
      BreadcrumbsStore.setItems([{ text: text, to: to }]);
    },

    addBreadcrumb (text, to = null) {
      BreadcrumbsStore.addItems([{ text: text, to: to }]);
    },

    addNewBreadcrumb () {
      this.addBreadcrumb("New");
    }
  }
};
